// extracted by mini-css-extract-plugin
export default {"domainSelectWrapper":"BusinessSSOEmailAddressDomain_domainSelectWrapper__irOIr","textButton":"BusinessSSOEmailAddressDomain_textButton__o4ti+"};